import { Button, CircularProgress, Grid } from '@material-ui/core';
import React from 'react';

const ShareFlagsModalFooter = ({
  onShareFlags,
  onCreateAndShare,
  isSharing,
  isButtonDisabled,
  activeStep,
  isCreatingGroup
}) => {
  const renderButtonContent = () => {
    if (activeStep === 11) {
      return (
        <>
          <span className="footer-btn__title">Create Group & Share</span>
          {isSharing && (
            <CircularProgress size={30} style={{ color: '#EDEEEF' }} />
          )}
        </>
      );
    }
    if (activeStep === 10) {
      return <></>;
    }

    return (
      <>
        <span className="footer-btn__title">Share</span>
        {!isSharing ? (
          <i
            className="fa fa-share-square-o footer-btn__icon"
            style={{ fontSize: '20px' }}
            aria-hidden="true"
          ></i>
        ) : (
          <CircularProgress style={{ color: '#EDEEEF' }} />
        )}
      </>
    );
  };

  const handleButtonAction = async () => {
    if (activeStep === 11) {
      onCreateAndShare();
      return;
    }
    onShareFlags();
  };

  return (
    <Grid
      container
      component="div"
      className="share-flags-modal__footer"
      alignItems="center"
    >
      <Grid item xs={12}>
        <Button
          className="share-flags-modal__footer-btn"
          style={{
            justifyContent:
              activeStep === 11 && !isSharing ? 'center' : 'space-between'
          }}
          onClick={handleButtonAction}
          disabled={isButtonDisabled() || isSharing || isCreatingGroup}
        >
          {renderButtonContent()}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ShareFlagsModalFooter;
